import React from 'react';
import loadable from '@loadable/component';

const Pagination = loadable(
  () => import(/* webpackChunkName: "Pagination.loadable" */ 'app/shared/modules/Pagination/Pagination/component'),
  {
    ssr: false,
  },
);

class LoadablePagination extends React.Component {
  render() {
    return <Pagination {...this.props} />;
  }
}

export default LoadablePagination;
